export function joinPath(...parts: (string | number)[]): string {
  return parts
    .filter(Boolean)
    .map((part) => part.toString().replace(/^\/|\/$/g, ''))
    .join('/');
}
